import * as api from '../../data/api/api';
import {IFilter} from '../../util/url';
import {IContent, IContentStore} from './models';

const REQUESTING_CONTENT = 'REQUESTING_CONTENT';
const SET_CONTENT = 'SET_CONTENT';
const CLEAR_CONTENT = 'CLEAR_CONTENT';
const SET_PAGES = 'SET_PAGES';
const ADD_CONTENT = 'ADD_CONTENT';

const initialState = {
  requesting: false,
  content: [],
  pages: [],
};

export const reducer = (state = initialState, action) => {
  switch (action.type) {
    case REQUESTING_CONTENT:
      return {
        ...state,
        requesting: action.requesting,
      };

    case SET_CONTENT:
      return {
        ...state,
        content: action.data,
      };
    case SET_PAGES:
      return {
        ...state,
        pages: action.payload,
      };
    case CLEAR_CONTENT:
      return {
        ...state,
        content: [],
      };
    case ADD_CONTENT:
      return {
        ...state,
        content: [
          ...state.content,
          ...action.payload,
        ],
      };
    default:
      return state;
  }
};

const requestingContent = (requesting) => {
  return {
    type: REQUESTING_CONTENT,
    requesting,
  };
};

const setContent = (content) => {
  return {
    type: SET_CONTENT,
    data: content,
  };
};

const setPages = (pages) => {
  return {
    type: SET_PAGES,
    payload: pages,
  };
};

const clearContent = () => ({type: CLEAR_CONTENT});
const addContent = (content) => ({type: ADD_CONTENT, payload: content});

export const getContentFromState = (state: IContentStore, slug: string): IContent =>
  state.content.filter((content) => content.slug === slug)[0];

const getContent = (filters: IFilter) => (dispatch) => {
  dispatch(requestingContent(true));
  return api
    .listContents(filters)
    .then((contents) => {
      dispatch(addContent(contents));
      dispatch(requestingContent(false));
    });
};

const loadPageList = () => (dispatch) => {
  return api
    .listContents({'template.type': 'page'}, {contents: 'slug,name'})
    .then((content) => {
      dispatch(setPages(content.map(({name, slug}) => ({name, slug}))));
    });
};

export interface IContentActions {
  getContent(filters: IFilter);

  clearContent();

  loadPageList();

  setPages([]);
}

export const actions = {
  requestingContent,
  setContent,
  getContent,
  loadPageList,
  clearContent,
  setPages,
};



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/app/services/content/reducer.ts